import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, interval, switchMap, startWith, shareReplay } from 'rxjs';
import { global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  private latestVersion$: Observable<{ version: string }>;

  constructor(private http: HttpClient) {
    // Check for a new version every 5 minutes
    this.latestVersion$ = interval(5 * 60 * 1000).pipe(
      startWith(0), // Emit immediately on subscription
      switchMap(() => this.fetchLatestVersion()),
      shareReplay(1) // Cache the latest emission
    );
  }

  private fetchLatestVersion(): Observable<{ version: string }> {
    return this.http.get<{ version: string }>(global.url + 'latest-version');
  }

  getLatestVersion(): Observable<{ version: string }> {
    return this.latestVersion$;
  }
}
